import type { OnInit } from '@angular/core';
import { Component, HostBinding, Input } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { InnogyComponentRendering } from '@core/jss-models';
import { getItemLinkFieldValue, ScIconPipe } from '@core/jss-utils';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgClass } from '@angular/common';

import { RichTextComponent } from '../../rich-text/rich-text.component';

@Component({
  selector: 'wl-icon-list-item',
  templateUrl: './icon-list-item.component.html',
  styleUrls: [
    './icon-list-item.component.ed.scss',
    './icon-list-item.component.essent.scss',
  ],
  standalone: true,
  imports: [FaIconComponent, NgClass, RichTextComponent, ScIconPipe],
})
export class IconListItemComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() icon?: IconProp;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() iconColor = 'text-dark';

  @HostBinding('class') hostClasses = 'd-flex mb-2';

  ngOnInit(): void {
    if (!this.rendering || !this.rendering.fields) {
      return;
    }
    this.icon = getItemLinkFieldValue<IconProp>(
      this.rendering.fields,
      'iconName'
    );
    this.iconColor = getItemLinkFieldValue(
      this.rendering.fields,
      'iconColor',
      'text-dark'
    );
  }
}
